import { app } from '../../../app';
import { Controller } from './license-management.controller';

app.component('licenseManagement', {
    bindings:{
        licenseDetails: '<',
    },
    controller: Controller,
    templateUrl: require('./license-management.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/license-management/license-management.component.js